export enum NotificationType {
  Error = "ERROR",
  Info = "INFO",
  Success = "SUCCESS",
  Cancel = "CANCEL",
}
